import { User } from '../models/store';
import * as authActionTypes from '../models/action';

export const createUserAction = (user: User): authActionTypes.CreateUserAction => ({
  type: authActionTypes.CREATE_USER,
  payload: user,
});

export const updateUserPremiumStatusAction = (
  isPremiumUser: boolean
): authActionTypes.UpdateUserPremiumStatus => ({
  type: authActionTypes.UPDATE_USER_PREMIUM_STATUS,
  payload: isPremiumUser,
});

export const updateUserAdditionalDetailsAction = (
  user: User
): authActionTypes.UpdateUserAdditionalDetailsAction => ({
  type: authActionTypes.UPDATE_USER_ADDITIONAL_DETAILS,
  payload: user,
});

export const logoutUserAction = (): authActionTypes.LogoutUserAction => ({
  type: authActionTypes.LOGOUT_USER,
  payload: null,
});

export const loadingAction = (isLoading: boolean): authActionTypes.LoadingAction => ({
  type: authActionTypes.LOADING,
  payload: isLoading,
});

updateUserPremiumStatusAction(false);
